var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"page"}},[_c('first-Component',{attrs:{"menuindex":"5"}}),_c('div',{attrs:{"id":"scroller-wrapper","data-scrollbar":""}},[_c('home-Component')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }